import type { DynamicProperty } from '../types';

export function evaluateDynamicValue<Type>(input: DynamicProperty<Type>): Type {
  return input instanceof Function ? input() : input;
}
